import React, { memo, useContext } from 'react'
import { TableSelect } from 'src/components/shared/table/TableSelect'
import { SubcontractorRequestsTableContext } from '../SubcontractorRequestsTable.context'
import { GSIcon } from 'src/components/shared/GSIcon'
import { useSelector } from 'react-redux'
import { getMCWithPendingRequests } from 'src/selectors/mc'

const SubcontractorRequestsMCSelectComponent = () => {
  const { masterContractorFilter, setMasterContractorFilter } = useContext(
    SubcontractorRequestsTableContext,
  )

  const mcsWithPendingRequests = useSelector(getMCWithPendingRequests)

  if (!mcsWithPendingRequests.length) {
    return null
  }

  return (
    <TableSelect<string>
      title="Master contractor"
      selectedValues={masterContractorFilter}
      icon={<GSIcon iconName="gs_buildings" />}
      options={mcsWithPendingRequests.map((item) => ({
        value: item.masterContractorId,
        component: item.masterContractorName,
      }))}
      onSelect={setMasterContractorFilter}
    />
  )
}

export const SubcontractorRequestsMCSelect = memo(SubcontractorRequestsMCSelectComponent)
